import { combineReducers } from 'redux';
import documentsByPolicyId from './documents-by-policy-id';
import sendDocuments from './send-documents';
export { documentsByPolicyId, sendDocuments };
export default combineReducers({
    documentsByPolicyId,
    sendDocuments,
});
